import { QueryBuilderTokenType } from '../../../../../../types';

export const reorderTokensAtIndex = (
  tokens: QueryBuilderTokenType[],
  fromIndex: number,
  toIndex: number
): QueryBuilderTokenType[] => {
  if (
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= tokens.length ||
    toIndex >= tokens.length
  ) {
    return tokens;
  }

  const nextTokens = [...tokens];
  const [movedToken] = nextTokens.splice(fromIndex, 1);
  nextTokens.splice(toIndex, 0, movedToken);

  return nextTokens;
};
